import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Hook to award trophy to student after completing quest
 * @returns {{
 *  awardStudentCertificate: (payload: { quest_id: number, chapter_id: number }) => Promise<any>,
 *  loading: boolean,
 *  error: string
 * }}
 */
export const useAwardStudentCertificate = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  const awardStudentCertificate = async (payload) => {
    if (!payload?.quest_id || !payload?.chapter_id) {
      setError("quest_id and chapter_id are required");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.post(
        `${TENANT_DOMAIN}/student/award/certificate`,
        payload
      );

      return response?.data;
    } catch (err) {
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { awardStudentCertificate, loading, error };
};
